namespace $.$$ {
	export class $shm_hitalama_components_tests extends $.$shm_hitalama_components_tests {
		content_rows() { return this.tree_roots().length ? [ this.Scenarios() ] : [ this.Empty() ] }
		@ $mol_mem
		tree_nodes() {
			const nodes = new Map<string, { title: string, children: string[], scenario?: string }>()
			nodes.set( '', { title: '', children: [] } )
			for( const id of this.definition().Test_scenarios()?.keys() ?? [] ) {
				if( typeof id !== 'string' ) continue
				const scenario = this.definition().Test_scenarios()!.key( id )?.remote()
				if( !scenario ) continue
				this.$.$shm_hitalama_map_component_ready.read( scenario )
				const spec = this.$.$mol_error_fence( ()=> this.$.$shm_hitalama_components_scenario.validate( scenario.Spec()?.val() || '{}' ), ()=> ({ title: id, group: [ 'Некорректные сценарии' ], mode: 'demo' as const, steps: [] }) )
				let parent = ''
				const path: string[] = []
				for( const title of spec.group ?? [] ) {
					path.push( title )
					const key = 'group:' + JSON.stringify( path )
					if( !nodes.has( key ) ) {
						nodes.set( key, { title, children: [] } )
						nodes.get( parent )!.children.push( key )
					}
					parent = key
				}
				const key = 'scenario:' + id
				nodes.set( key, { title: spec.title || id, children: [], scenario: id } )
				nodes.get( parent )!.children.push( key )
			}
			return nodes
		}
		tree_roots() { return this.tree_nodes().get( '' )!.children }
		tree_children( key: string ) { return this.tree_nodes().get( key )?.children ?? [] }
		tree_title( key: string ) { return this.tree_nodes().get( key )?.title ?? key }
		tree_selected( key: string ) { return this.tree_nodes().get( key )?.scenario === this.selected() }
		@ $mol_action
		choose( key: string, event?: Event ) {
			if( !event ) return null
			const id = this.tree_nodes().get( key )?.scenario
			if( id ) this.selected( id )
			else this.Scenarios().expanded( key, !this.Scenarios().expanded( key ) )
			return null
		}
	}
}
